import FormInputs from "../../services/inputs-service.js";
import Funnel from "../../services/funnel-service.js";
import Utils from "../../services/utils-service.js";

const template = `
<div v-show="fs.display(input)">
    <button
        v-if="!input.button_type || input.button_type == 1"
        :id="input.id"
        :class="input.btn_class ? computedInputClass : 'button medium action fill primary-btn'"
        @click.prevent="exec($event, input)"
        v-bind="validationRules"
        :data-uid="input.uid+'_btn'"
        v-html="computedText"
        :disabled="computedDisable"
        :aria-disabled="computedDisable"
        :aria-describedby="input.uid+'-error-announcement'"
        role="button"
        aria-pressed="false"
    ></button>
    <button
        v-if="input.button_type == 2 || input.button_type == 'link'"
        :id="input.id"
        :class="input.btn_class"
        @click.prevent="exec($event, input)"
        v-bind="validationRules"
        :data-uid="input.uid+'_btn'"
        v-html="computedText"
        :aria-describedby="input.uid+'-error-announcement'"
        role="button"
        aria-pressed="false"
    ></button>
    <small aria-live="polite" :id="input.uid+'-error-announcement'" class="sr-only">{{computedAnnouncement}}</small>
    <div aria-live="polite" aria-atomic="true" class="sr-only" :id="input.id+'_button_announcer'" v-html="computedDisable ? 'Button for '+computedText+ ' is now disabled, please enter the required data to enable.' : 'Button for '+computedText+ ' is now enabled.'"></div>
</div>
`;

export default {
    name: 'qt-button',
    template,
    props: ['iuid'],
    computed: {
        fs: function () {
            return new Funnel({ ctx: this.$store, router: this.$router });
        },
        validationRules () {
            return this.input.validation
        },
        computedText: function(){
            let btnText = ''

            if (this.input.btn_text) {
                btnText = this.input.btn_text
            }else{
                btnText = this.input.label
            }
            
            if (!Utils.isObjEmpty(this.input.btn_text_values)) {
                const fs = new Funnel({ ctx: this.$store, router: this.$router });
                for (const btn_text_value of this.input.btn_text_values) {
                    if (fs.display(btn_text_value)) {
                        btnText = btn_text_value.text;
                    }
                }
            }
            console.log("btn text: "+ btnText);
            return btnText;
        },
        input: function () {
            return this.$store.getters.funnel.elements[this.iuid];
        },
        computedInputClass: function(){
            if(this.input.value && String(this.input.value).length === 5){
                return this.input.btn_class+' activate'
            }
            var computedDisable =''

            if (this.computedDisable) {
                computedDisable =' disabled '
            }
            return this.input.btn_class + computedDisable
        },
        
        computedDisable: function(){
            if(!this.input.value){
                var val = null;
                if(!this.input.type == 'button'){
                    //if it's just a button
                    return false
                }else if(!this.input.value && this.input.type != 'button'){
                    // if the button is part of another field. 
                    return true
                }
            }
        },
        computedAnnouncement: function(){
            if (document.getElementById(this.input.uid+'-error')) {
               return "There are fileds with invalid entries, complete the form to proceed"
            }
            
        }
    },
    methods: {
        exec: function (e, input) {
            const fi = new FormInputs({ ctx: this.$store, router: this.$router });
            fi.eventHandler(e, input);
        }
    }
};